import { DynamicPageData, DynamicPageType } from '@/types/cms';
import { GetServerSidePropsContext } from 'next';
import React, { useEffect } from 'react';
import { DynamicPageDataProps, getDynamicPageData } from 'utils/getDynamicPageData';
import { useAnalytics } from 'utils/useAnalytics';

import { DynamicPage } from 'components/CMS/DynamicPage';

import styles from './style.module.scss';

const ContactUsLandingPage = ({ data, pageData }: DynamicPageData) => {
  const track = useAnalytics();

  useEffect(() => {
    track('ContactUsLandingPage loaded', {});

    const elementLinks: {
      [key: string]: {
        element: NodeListOf<Element>;
        track: (event: Event) => void;
      };
    } = {
      phoneNumber: {
        element: document.querySelectorAll(`[href*="tel:"]`),
        track: event => {
          // We need to get the phone number from the anchor link which is `tel:+XXXXX`
          const phoneNumber = (event.target as HTMLAnchorElement).href.slice(4);
          track('Contact us via call', { phone_number: phoneNumber });
        },
      },
      emailLink: {
        element: document.querySelectorAll('[href*="mailto:info@medrecruit.com"]'),
        track: () => track('Contact us via email', { form_filled: false, email_link: true }),
      },
      submitButton: {
        element: document.querySelectorAll('button[type="submit"]'),
        track: () => track('Contact us via email', { form_filled: true, email_link: false }),
      },
    };

    for (const key in elementLinks) {
      const link = elementLinks[key];

      link.element.forEach(element => {
        element.addEventListener('click', event => link.track(event));
      });
    }
  });

  return (
    <div className={styles.contactUsLanding}>
      <DynamicPage data={data} pageData={pageData} />
    </div>
  );
};

export async function getServerSideProps(
  context: GetServerSidePropsContext,
): Promise<DynamicPageDataProps> {
  const {
    modules = [],
    pageData,
    error,
  } = await getDynamicPageData(DynamicPageType.Contact_Us_Landing_Page, context);

  if (error) {
    return { notFound: true, props: { error } };
  }

  if (pageData?.redirect_url) {
    const { res } = context;
    if (res) {
      res.writeHead(301, { Location: pageData?.redirect_url });
      res.end();
    }
  }

  return { props: { data: modules, pageData } };
}

export default ContactUsLandingPage;
